import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

//TO-DO: React.StrictMode has a bug for the MapView.
root.render(
    <>
        <style>
            {`
                .toast-high-z-index {
                    z-index: 99999 !important;
                }
                .Toastify__toast-container {
                    z-index: 99999 !important;
                }
                .Toastify__toast {
                    z-index: 99999 !important;
                }
                .Toastify__toast-body {
                    z-index: 99999 !important;
                }
                .Toastify__progress-bar {
                    z-index: 99999 !important;
                }
            `}
        </style>
        <App/>
        <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            toastClassName="toast-high-z-index"
        />
    </>
);
